module.exports = new __parcel__URL__("instagram.7e42ced3.svg").toString();